const { startLobby, constructSignupLobbyHTML, constructSignedInHTML } = require('./lobby');
const replay = require('./replay');
const joinCustom = require('./joinCustom');
const { incrementCounterValue, observeHistogramMetric } = require('./frontendStats');

if (window.location.pathname.startsWith("/game/join/"))
{
	incrementCounterValue("start_url", "join");
	joinCustom.entry(window.location.pathname.replace("/game/join/", ""), (name) => constructSignedInHTML(name));
}
else if (window.location.pathname.startsWith("/game/replay/"))
{
	incrementCounterValue("start_url", "replay");
	var url = new URL(window.location);
	const urlParams = new URLSearchParams(window.location.search);
	const playerId = urlParams.get('p');
	replay.entry(window.location.pathname.replace("/game/replay/", ""), constructSignupLobbyHTML, playerId);
}
else
{
	incrementCounterValue("start_url", "main");
	startLobby();
}
